import src from "IMAGE";
export default { src, width: 445, height: 204, blurWidth: 0, blurHeight: 0};
